import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  showAlert = false;
  constructor() { }

  ngOnInit() {
  }

  closeAlert() {

  }
}
